import { Quote } from "lucide-react";
import { Reveal, Chapter, Stagger, StaggerItem } from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLang } from "@/i18n";

const Results = () => {
  const { t } = useLang();
  const r = t.results;

  return (
    <section id="results" data-testid="results-section" className="py-24 md:py-32">
      <div className="container-x">
        <Chapter num="07" label={r.chapter} />

        <h2 className="font-display text-4xl md:text-5xl lg:text-7xl uppercase tracking-tight leading-[0.9]">
          {r.titleA} <span className="text-[#D91624]">{r.titleB}</span>
        </h2>

        <Stagger className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
          {r.testimonials.map((tst, i) => (
            <StaggerItem key={tst.name}>
              <figure
                data-testid={`testimonial-${i}`}
                className="h-full bg-[#121212] border border-white/10 p-8 flex flex-col"
              >
                <Quote size={28} className="text-[#D91624]" />
                <blockquote className="mt-4 text-base md:text-lg text-neutral-300 leading-relaxed grow">
                  "{tst.quote}"
                </blockquote>
                <figcaption className="mt-6 pt-4 border-t border-white/10">
                  <p className="font-bold text-white">{tst.name}</p>
                  <p className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] font-bold mt-1">
                    {tst.tag}
                  </p>
                </figcaption>
              </figure>
            </StaggerItem>
          ))}
        </Stagger>

        <div className="mt-24 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <Reveal className="lg:col-span-4">
            <h3 className="font-display text-3xl md:text-5xl uppercase tracking-tight leading-[0.9]">
              {r.faqTitleA} <span className="text-[#D4AF37]">{r.faqTitleB}</span>
            </h3>
            <p className="mt-4 text-neutral-400 leading-relaxed">{r.faqIntro}</p>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-8">
            <Accordion type="single" collapsible data-testid="faq-accordion" className="border-t border-white/10">
              {r.faqs.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  className="border-b border-white/10"
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="text-left text-base md:text-lg font-bold text-white hover:text-[#D4AF37] py-6 hover:no-underline transition-colors duration-300"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-content-${i}`}
                    className="text-neutral-400 leading-relaxed pb-6"
                  >
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Results;
